import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
